import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { actionCreators } from '../../store/modules/Publication';
import Image from '../../controls/ImageUpload';
import date from '../../utils/date';
import SaveButton from '../../controls/SaveButton';
import DeleteButton from '../../controls/DeleteButton';
import BackButton from '../../controls/BackButton';
import confirm from '../../utils/confirm';

class PublicationEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id === 'new' ? null : Number(props.match.params.id),
    };
    this.form = React.createRef();
  }

  componentWillMount() {
    const { id } = this.state;
    const { requestGet } = this.props;

    if (id) {
      requestGet(id);
    }
  }

  handleSave(values) {
    const { id } = this.state;
    const { requestPost, requestPut } = this.props;

    if (id) {
      requestPut(id, JSON.stringify(values));
    } else {
      confirm('Vai tiešām vēlaties saglabāt un izsūtīt notifikācijas? Tas var aizņemt vairākas minūtes.').then(() => requestPost(JSON.stringify(values)));
    }
  }

  render() {
    const { publication, requestDelete } = this.props;
    const { id } = this.state;

    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          name: Yup.string().required(),
          description: Yup.string().required(),
          imageId: Yup.string().nullable(),
        })}
        initialValues={id && publication && publication.id === id ? publication : { name: '', description: '', imageId: '' }}
        render={({ values, errors }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-md-12">
                  <span className="page-title hex-img">{id ? 'Publikācija' : 'Jauna Publikācija'}</span>
                  <div className="pageStyle">
                    <BackButton />
                    {id && <DeleteButton onClick={() => requestDelete(id)} />}
                    <SaveButton />
                  </div>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default hex">
                    <div className="octomask">
                      <div className="octomask1" />
                    </div>
                    <div className="octo">
                      <div className="octo1">
                        <Image imageIds={[values.imageId]} form={this.form}
                          single />
                      </div>
                    </div>
                    <div className="panel-heading" />
                    <div className="panel-body hex" id="scroller">
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="name" className="control-label font-bold">
                                Nosaukums (optimāli līdz 110 simboliem)
                                <Field id="name"
                                  name="name"
                                  autoFocus
                                  className={errors.name ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="description" className="control-label font-bold">
                                Apraksts (neierobežots garums)
                                <Field id="description"
                                  name="description"
                                  component="textarea"
                                  rows="10"
                                  className={errors.description ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {id
                        && publication && (
                          <div className="col-sm-3 form-additional-info">
                            <label>
                              Izveidots
                              <div>{date.long(publication.createdOn)}</div>
                            </label>
                            <label>
                              Notifikācijas
                              <div>{publication.pushNotificationCount}</div>
                              <div>{publication.successfulPushNotificationCount} piegādātas</div>
                              <div>{publication.failedPushNotificationCount} kļūdainas</div>
                            </label>
                          </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

PublicationEdit.propTypes = {
  publication: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  requestGet: PropTypes.func.isRequired,
  requestPost: PropTypes.func.isRequired,
  requestPut: PropTypes.func.isRequired,
  requestDelete: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
};

PublicationEdit.defaultProps = {
  publication: null,
};

export default connect(
  state => ({
    publication: state.publication.current,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(PublicationEdit);



// WEBPACK FOOTER //
// ./src/components/publication/Edit.jsx